module.exports = __webpack_public_path__ + "img/wenjiang5.0d78d9c5.png";